import { render, staticRenderFns } from "./PersonalDataAgreement.vue?vue&type=template&id=619458fc&scoped=true&"
import script from "./PersonalDataAgreement.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619458fc",
  null
  
)

export default component.exports